import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { IMG } from "@/config";
import { PortalButton } from "@/components/PortalButton";
import { Reveal } from "@/components/Reveal";

export default function FinalCta() {
  return (
    <section data-testid="final-cta" className="relative py-28 md:py-40 overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMG.warehouseShelves} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-forest-deep/90" />
      </div>
      <div className="relative max-w-[1440px] mx-auto px-5 md:px-10 text-center flex flex-col items-center">
        <Reveal>
          <span className="overline text-butter-deep">Ready When You Are</span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-cream leading-[1.03] tracking-tight mt-4 max-w-4xl text-balance">
            Ready to simplify your restaurant purchasing?
          </h2>
          <p className="text-cream/75 text-lg mt-6 max-w-2xl mx-auto">
            Open your Brampton Cash &amp; Carry wholesale account, access competitive pricing and start receiving the products your business needs.
          </p>
        </Reveal>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.15 }} className="flex flex-col sm:flex-row gap-3 mt-9">
          <PortalButton variant="butter" testId="final-open-account-btn">Open My Wholesale Account</PortalButton>
          <Link to="/contact" data-testid="final-speak-team-btn" className="inline-flex items-center gap-2 rounded-full border border-cream/40 text-cream px-6 py-3 text-sm font-semibold hover:bg-cream hover:text-forest transition-colors duration-300">
            <Phone className="h-4 w-4" /> Speak With Our Team
          </Link>
        </motion.div>
        <p className="text-cream/60 text-sm mt-6 font-mono-accent">New approved customers may begin ordering as early as the next available delivery day.</p>
      </div>
    </section>
  );
}
